/* unplugin-vue-components disabled */import { render } from "./member_details.vue?vue&type=template&id=583ed770&scoped=true"
import script from "./member_details.vue?vue&type=script&lang=js"
export * from "./member_details.vue?vue&type=script&lang=js"

import "./member_details.vue?vue&type=style&index=0&id=583ed770&lang=scss&scoped=true"
import "./member_details.vue?vue&type=style&index=1&id=583ed770&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583ed770"]])

export default __exports__